<template src="./TripManifest.html">

</template>

<script>
import { getRoutes } from '@/services/routes'
import { getVehicles } from '@/services/vehicle'
import { postTrip, getTrip, putTrip } from '@/services/trip'
import { getDrivers } from '@/services/driver'
import { getPassengers } from '@/services/passenger'
import { format } from 'date-fns'

export default {
  name: 'TripManifest',
  data () {
    const now = new Date()
    return {
      locationRoutes: [],
      vehicles: [],
      drivers: [],
      hide: false,
      passengersRefs: [],
      selectedPassengers: [],
      isUpdating: false,
      tripInfo: null,
      depDate: '',
      model: {
        driver: null,
        description: '',
        dep_date: now,
        arrival_date: now,
        route: null,
        vehicle: null,
        addtional_info: null
      }
    }
  },

  watch: {
    'model.route' (oldValue, value) {
    }
  },

  mounted () {
    this.loadLocationRoute()
  },

  methods: {

    getTripInfo () {
      const { id: tripId } = this.$route.params
      if (tripId) {
        getTrip(parseInt(tripId, 10))
          .then(res => {
            this.tripInfo = res.data
            this.setTripDetails(res.data)
          }).catch(() => {
            this.$message.error('Error loading this trip to update')
          })
      }
    },

    setTripDetails (data) {
      this.isUpdating = true
      const {
        description,
        route: { id: route },
        dep_date: depDate,
        vehicle: { id: vehicle },
        driver: { id: driver },
        arrival_date: arrivalDate,
        ticket_refs: ticketRefs
      } = data

      this.model = {
        description,
        route,
        dep_date: depDate,
        vehicle,
        driver,
        arrivalDate,
        addtional_info: data.addtional_info
      }
      this.onHandleLoadPassengerByDateRoute()
      this.selectedPassengers = ticketRefs.split(':')
    },

    loadLocationRoute () {
      getRoutes()
        .then(res => {
          this.locationRoutes = res.data
          this.loadVehicles()
        })
    },

    loadVehicles () {
      getVehicles()
        .then(res => {
          this.vehicles = res.data
          this.loadDrivers()
        })
    },

    loadDrivers () {
      getDrivers()
        .then(res => {
          this.drivers = res.data
          this.getTripInfo()
        })
    },

    handleUpdateManifest () {
      const m = this.model
      const depDate = format(new Date(m.dep_date), 'YYYY-MM-DD')
      const payload = {
        ...m,
        dep_date: depDate,
        ticket_refs: this.selectedPassengers.join(':')
      }

      let httpRequest
      if (this.isUpdating && this.tripInfo) {
        httpRequest = putTrip
        payload.id = this.tripInfo.id
      } else {
        httpRequest = postTrip
      }

      httpRequest(payload)
        .then(res => {
          this.$notify.success({
            message: 'Manifest Saved successfully'
          })
          this.$router.push({ name: 'Trips' })
        })
    },

    onHandleLoadPassengerByDateRoute () {
      const { dep_date: byDepautureDate, route } = this.model
      if (!byDepautureDate) {
        this.$message.error('Please select a trip departure date')
        return
      }

      if (!route) {
        this.$message.error('Please select a valid route')
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading passenger for this trip summary',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let queryParams = ''
      if (byDepautureDate) {
        const fDate = format(new Date(byDepautureDate), 'YYYY-MM-DD')
        queryParams = `dep_date=${fDate}`
      }
      if (route) {
        queryParams = `${queryParams}&route=${route}`
      }
      // get only the reference field
      queryParams = `${queryParams}&fields=ref`
      getPassengers(queryParams)
        .then(res => {
          loading.close()
          this.passengersRefs = res.data.map(p => p.ref)
        }).catch(() => {
          loading.close()
          this.$message('Error loading passenger for this route and date')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/trips/TripManifest.vue